<script setup lang="ts">
// The landing hero on the paper theatre's night sky (HeroSky: moon and stars on
// strings, paper hills), the copy on the left and the "try it" demo pinned on the
// right (below on phones). The copy is plain server-rendered text — the LCP element.
import HeroSky from './HeroSky.vue';
import MegaTrustAvatars from './MegaTrustAvatars.vue';
import OnboardingBlock from './OnboardingBlock.vue';
</script>

<template>
  <header class="relative isolate pb-20 pt-24 md:pb-32 md:pt-36">
    <HeroSky class="-z-10" />

    <div
      class="site-container grid grid-cols-1 items-center gap-10 md:grid-cols-2 md:gap-14"
    >
      <div>
        <div class="type-overline mb-[22px] text-primary-ink">
          кот-таролог · живёт в Telegram
        </div>
        <h1 class="type-display">
          Мурчим<br /><span class="text-primary-ink">твою судьбу</span>
        </h1>
        <p class="my-6 max-w-[460px] text-lg leading-relaxed text-muted-foreground sm:text-xl">
          Задай вопрос своими словами — вытяни карту — получи честный, тёплый ответ от кота, который всегда на связи.
        </p>
        <div class="mb-[30px] flex items-center gap-4">
          <MegaTrustAvatars />
          <div>
            <div class="type-body-strong leading-snug text-foreground">2 000+ человек уже гадают с котом</div>
            <div class="type-caption tabular-nums">21 000 раскладов · 16 видов · 24/7</div>
          </div>
        </div>
        <div class="type-body-strong inline-flex items-center gap-2.5 text-primary-ink">
          <span aria-hidden="true">→</span> Просто спроси — кот уже здесь
        </div>
      </div>

      <div>
        <OnboardingBlock />
      </div>
    </div>
  </header>
</template>
